import React, { useState } from "react";
import { Table, Typography, Tag, Button, Space } from "antd";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import moment from "moment";
import RestrictedComponent from "../../../../components/util/RestrictedComponent";

const { Text } = Typography;
const HolidaysTable = (props) => {
  const { onEditClick } = props;
  const intl = useIntl();
  const [deletedId, setDeletedId] = useState(null);

  const deleteLoading = useSelector(
    (state) => state.pendingActions["systemTable/delete_item"]
  );

  const { items, onDelete } = props;
  const onDeleteRow = (row, item) => {
    setDeletedId(item.id);
    onDelete(item);
  };

  const onEdit = (row, item) => {
    onEditClick(item);
  };

  const columns = [
    {
      title: <FormattedMessage id="app.forms.holiday.name" />,
      dataIndex: "name",
      width: "200px",
      render(text, record) {
        return <Text>{text}</Text>;
      },
    },
    {
      title: <FormattedMessage id="app.forms.holiday.date" />,
      dataIndex: "date",
      sortIndex: "date",
      sorter: (a, b) => a["date"].localeCompare(b["date"]),
      defaultSortOrder: "descend",
      sortDirections: ["ascend", "descend", "ascend"],
      width: "200px",
      render(text, record) {
        return <Text>{moment(text).format("DD/MM/YYYY")}</Text>;
      },
    },
    {
      title: <FormattedMessage id="app.forms.holiday.holiday_evening" />,
      dataIndex: "holiday_evening",
      width: "200px",
      render(text, record) {
        return text ? (
          <Tag>
            {intl.formatMessage({
              id: "app.holiday.holiday_evening",
            })}
          </Tag>
        ) : null;
      },
    },
    {
      title: <FormattedMessage id="app.forms.holiday.actions" />,
      dataIndex: "actions",
      render: (row, index) => (
        <RestrictedComponent
          resource={"organization.settings"}
          action={"editor"}
          comp={null}
        >
          <Space size="middle">
            <Button type="text" onClick={() => onEdit(row, index)}>
              <FormattedMessage id={"app.actions.edit"} />
            </Button>

            <Button
              loading={deleteLoading && index.id === deletedId}
              danger
              type="text"
              onClick={() => onDeleteRow(row, index)}
            >
              <FormattedMessage id={"app.actions.delete"} />
            </Button>
          </Space>
        </RestrictedComponent>
      ),
    },
  ];

  return (
    <Table
      bordered
      columns={columns}
      dataSource={items}
      rowKey={(record) => record.id}
      style={{ height: window.innerHeight - 442 }}
      scroll={{ y: window.innerHeight - 546 }}
      pagination={false}
    />
  );
};

export default HolidaysTable;
